import React from 'react';
import { BrandColor } from '@styleseat/brand';

type VariousSparklesIconProps = {
  width?: number;
  height?: number;
  color?: string;
} & React.SVGProps<SVGSVGElement>;

export const VariousSparklesIcon = ({
  width = 14,
  height = 16,
  color = BrandColor.BackInBlack,
}: VariousSparklesIconProps) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 14 16"
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M11.5219 6.00008L12.2799 4.16675L13.9476 3.33341L12.2799 2.50008L11.5219 0.666748L10.7639 2.50008L9.09624 3.33341L10.7639 4.16675L11.5219 6.00008ZM6.97379 6.33341L5.45776 2.66675L3.94172 6.33341L0.606445 8.00008L3.94172 9.66675L5.45776 13.3334L6.97379 9.66675L10.3091 8.00008L6.97379 6.33341ZM11.5219 10.0001L10.7639 11.8334L9.09624 12.6667L10.7639 13.5001L11.5219 15.3334L12.2799 13.5001L13.9476 12.6667L12.2799 11.8334L11.5219 10.0001Z" fill={color} />
  </svg>

);
